import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  analyticsApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  errorApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { MultipleAnalyticsApi } from '@backstage/core-app-api';
import {
  DefaultMayContributeEntitiesApi,
  mayContributeEntitiesApiRef,
  DefaultMayReuseEntitiesApi,
  mayReuseEntitiesApiRef,
} from '@internal/backstage-plugin-catalog-additional-actions';
import { DBAnalyticsAPI } from '@internal/backstage-plugin-analytics-module-db';

import { CustomTechRadar } from './plugins/tech-radar';

export const apis: AnyApiFactory[] = [
  // SCM Integrations API
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  // May Contribute Entities API
  createApiFactory({
    api: mayContributeEntitiesApiRef,
    deps: { storageApi: storageApiRef },
    factory: ({ storageApi }) =>
      new DefaultMayContributeEntitiesApi({ storageApi }),
  }),

  // May Reuse Entities API
  createApiFactory({
    api: mayReuseEntitiesApiRef,
    deps: { storageApi: storageApiRef },
    factory: ({ storageApi }) => new DefaultMayReuseEntitiesApi({ storageApi }),
  }),

  // Custom Tech Radar data
  createApiFactory(techRadarApiRef, new CustomTechRadar()),

  // Multiple Analytics API
  createApiFactory({
    api: analyticsApiRef,
    deps: {
      configApi: configApiRef,
      errorApi: errorApiRef,
      identityApi: identityApiRef,
      catalogApi: catalogApiRef,
      discoveryApi: discoveryApiRef,
    },
    factory: ({ configApi, errorApi, identityApi, catalogApi, discoveryApi }) =>
      MultipleAnalyticsApi.fromApis([
        GoogleAnalytics4.fromConfig(configApi, {
          identityApi,
        }),
        DBAnalyticsAPI.fromConfig(
          configApi,
          errorApi,
          identityApi,
          catalogApi,
          discoveryApi,
        ),
      ]),
  }),
];
